import React from 'react';
import PropTypes from 'prop-types';

import {
    FacebookShareButton,
    TwitterShareButton,
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
    WhatsappShareButton,
    EmailIcon,
    EmailShareButton,
    PocketShareButton,
    PocketIcon,
} from 'react-share';
import { injectIntl } from 'react-intl';
import Module from '../../../application/Service/Module';

export const SocialMediaSharing = ({ intl, style, title, description, childStyle }) =>
{
    return (
        <div style={style} className="social-media-links">
            <FacebookShareButton
                style={childStyle}
                url={Module.get().location.href}
                hashtag="#glaubensfutter"
                quote={title + '\n\n' + description}
            >
                <FacebookIcon
                    size={38}
                    round={true}
                />
            </FacebookShareButton>
            <TwitterShareButton
                style={childStyle}
                url={Module.get().location.href}
                title={title}
                hashtags={[ 'glaubensfutter' ]}
            >
                <TwitterIcon
                    size={38}
                    round={true} />
            </TwitterShareButton>
            <WhatsappShareButton
                style={childStyle}
                url={Module.get().location.href}
                title={title}
                separator=": "
            >
                <WhatsappIcon size={38} round={true} />
            </WhatsappShareButton>
            <PocketShareButton
                style={childStyle}
                url={Module.get().location.href}
                title={title}
                // separator=": "
            >
                <PocketIcon size={38} round={true} />
            </PocketShareButton>
            <EmailShareButton
                style={childStyle}
                url={Module.get().location.href}
                subject={title}
                body={`${intl.formatMessage({ 'id': 'check_out_article' })} \n\n  ${Module.get().location.href} \n\n  ${description}`}
            >
                <EmailIcon
                    size={38}
                    round={true}
                />
            </EmailShareButton>
        </div>
    );
};

SocialMediaSharing.propTypes = {
    style: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    childStyle: PropTypes.object,
    intl: PropTypes.object,
};

export default injectIntl(SocialMediaSharing);
